import { myTypeOf } from '@/utils/myTypeOf.js'
/**
 * 合并深层嵌套的对象，解决Object.assign() 无法处理深层嵌套对象，传参和Object.assign一样
 * @param {*} target
 * @param  {...any} sources
 * @returns
 */
export const deepMergeObjects = (target, ...sources) => {
  // 遍历 sources，将每个源对象的属性合并到目标对象中
  for (const source of sources) {
    // 如果 target 或 source 不是对象，则返回 source
    if (typeof target !== 'object' || typeof source !== 'object') {
      target = source
      continue
    }
    // 如果 source 是数组，则合并每个元素
    if (Array.isArray(source)) {
      target = Array.isArray(target) ? target : []
      for (let i = 0; i < source.length; i++) {
        target[i] = deepMergeObjects(target[i], source[i])
      }
      continue
    }
    // 将 source 的属性合并到 target 中
    for (const key in source) {
      target[key] = deepMergeObjects(target[key], source[key])
    }
  }
  return target
}
export const deepMergeObjectsWithIgnore = (newConfig, oldConfig) => {

  // 将旧数据，覆盖新数据
  for (const key in oldConfig) {
    if (['String', 'Number', 'Boolean'].includes(myTypeOf(oldConfig[key]))) {
      newConfig[key] = oldConfig[key]
    }
    if (myTypeOf(oldConfig[key]) == 'Object') {
      deepMergeObjectsWithIgnore(newConfig[key], oldConfig[key])
    }
    // 数组需要做特殊处理
    if (myTypeOf(oldConfig[key]) == 'Array') {
      if (key == 'config' || key == 'reportLogoList') {
        newConfig[key] = oldConfig[key]
      }
      if (key == 'reportCoverList') {
        // newConfig[key] = [...oldConfig[key], ...newConfig[key]]
        newConfig[key] = removeArrayObjectDuplication([...oldConfig[key], ...newConfig[key]], 'uid')
      }
      if (key == 'footerCoverList') {
        newConfig[key] = oldConfig[key]
      }
    }
  }
}

// 去除数组对象中重复的项
// uniqueKey，用来指定去重的key
export const removeArrayObjectDuplication = (arr, uniqueKey = 'uid') => {
  return arr.filter((item, index, self) =>
    index === self.findIndex((t) => t[uniqueKey] === item[uniqueKey])
  )
}
